module.exports = __webpack_public_path__ + "img/gestao_usuario_icon.429f2ef9.svg";